import { UUID } from 'crypto'
import { UserDto } from '../../pages/users/api/dto/get/UserDto'
import { UsersDto } from '../../pages/users/api/dto/get/UsersDto'
import { StudentUI } from '../../pages/users/model/StudentUI'
import { StudentsUI } from '../../pages/users/model/StudentsUI'
import User from './User'

class Users {
  private constructor(users: User[]) {
    this.users = users
  }

  private readonly users: User[]

  findStudentById(studentId: UUID): User | undefined {
    return this.users.find((user: User) => user.findByStudentId(studentId))
  }

  getStudents(): Users {
    const students = this.users.filter((user: User) => user.isStudent())
    return new Users(students)
  }

  toStudentsUI(): StudentsUI {
    const studentsUI: StudentUI[] = this.users
      .map((user: User) => {
        return user.toStudentUI()
      })
      .filter(
        (studentUI: StudentUI | undefined) => studentUI !== undefined,
      ) as StudentUI[]

    return {
      students: studentsUI,
    } satisfies StudentsUI
  }

  isEmpty(): boolean {
    return this.users.length === 0
  }

  static empty(): Users {
    return new Users([])
  }

  static fromDto(usersDto: UsersDto): Users {
    return new Users(
      usersDto.users.map((userDto: UserDto) => User.fromDto(userDto)),
    )
  }
}

export default Users
